export default "__VITE_ASSET__C$NScKWb__"